import React from 'react';

const Modal = ({ isOpen, onClose, children }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100]">
            <div className="bg-white rounded-lg w-11/12 md:w-3/4 lg:w-1/2">
                <span className="cursor-pointer absolute top-4 right-4 text-3xl text-white" onClick={onClose}>
                    &times;
                </span>
                {children}
            </div>
        </div>
    );
};

export default Modal; 